import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c048e38&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "styles/components/queryHeader.css?vue&type=style&index=0&id=2c048e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c048e38",
  null
  
)

export default component.exports